/* preloader.js — runs only first visit per session. Hardened: any failure restores page scroll. */
(function () {
  'use strict';
  try {
    const KEY = 'dandy_loaded';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const el = document.querySelector('[data-preloader]');
    if (!el) return;

    const seen = sessionStorage.getItem(KEY);
    if (seen || reduceMotion) { el.remove(); return; }

    document.body.style.overflow = 'hidden';
    el.classList.add('is-running');

    const finish = () => {
      try {
        el.classList.add('is-done');
        sessionStorage.setItem(KEY, '1');
        document.body.style.overflow = '';
        setTimeout(() => el.remove(), 700);
      } catch (e) { document.body.style.overflow = ''; }
    };

    setTimeout(finish, 1800);
  } catch (e) { document.body.style.overflow = ''; console.error('preloader.js failed', e); }
})();
